<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">备案</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">首次备案</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">首次备案</div>
      </div>
      <div class="panel-body">
        <div class="alert-warn margin-bottom-20">
          请务必填写真实有效信息。
        </div>
        <el-form v-if="sessionBeian.beian_path" :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="230px" class="beian-ruleForm">
          <el-form-item label="单位名称：" prop="name" :show-message="!formFocus.name">
            <el-input v-model="ruleForm.name" placeholder="请填写正确的单位名称" @focus="formFocus.name = true" @blur="formFocus.name = false"></el-input>
            <div class="icp-tip" v-show="formFocus.name">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请填写证件上的单位或机构名称！
              </div>
            </div>
          </el-form-item>
          <el-form-item label="单位性质：" prop="nature">
            <!--<el-select v-model="ruleForm.nature" placeholder="&#45;&#45;请选择&#45;&#45;" @focus="formFocus.nature = true" @blur="formFocus.nature = false">
              <el-option
                v-for="item in ruleForm.dwxz"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div class="icp-tip" v-show="formFocus.nature">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请选择您主办单位的性质
              </div>
            </div>-->
            {{ruleForm.nature}}
          </el-form-item>
          <el-form-item label="单位证件类型：" prop="certificate">
            <!--<el-select v-model="ruleForm.certificate" placeholder="&#45;&#45;请选择&#45;&#45;" @focus="formFocus.certificate = true" @blur="formFocus.certificate = false">
              <el-option
                v-for="item in ruleForm.zjlx"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div class="icp-tip" v-show="formFocus.certificate">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请选择您的主办单位证件类型
              </div>
            </div>-->
            {{ruleForm.certificate}}
          </el-form-item>
          <el-form-item label="单位证件号码：" prop="number" :show-message="!formFocus.number">
            <!--<el-input v-model="ruleForm.number" @focus="formFocus.number = true" @blur="formFocus.number = false"></el-input>
            <div class="icp-tip" v-show="formFocus.number">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请选择您的主办单位证件类型
              </div>
            </div>-->
            {{ruleForm.number}}
          </el-form-item>
          <el-form-item label="单位证件登记地址：" prop="address" :show-message="!formFocus.address">
            <el-input v-model="ruleForm.address" placeholder="请与证件地址保持一致，4-250个字符" @focus="formFocus.address = true" @blur="formFocus.address = false"></el-input>
            <div class="icp-tip" v-show="formFocus.address">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请与证件地址保持一致，4-250个字符
              </div>
            </div>
          </el-form-item>
          <el-form-item label="单位所在地：">
            <!--<xbeian-city :province="cityInfo['province']" :city="cityInfo['city']" :area="cityInfo['area']" :DISTRICTS="DISTRICTS" v-model="cityInfo"></xbeian-city>-->
            {{cityInfo.province}} {{cityInfo.city}} {{cityInfo.area}}
          </el-form-item>
          <el-form-item label="单位通讯地址：" prop="commun" :show-message="!formFocus.commun">
            {{cityInfo.province}}{{cityInfo.area}}<el-input v-model="ruleForm.commun" style="width: 234px;margin-left: 56px;" @focus="formFocus.commun = true" @blur="formFocus.commun = false"></el-input>
            <div class="icp-tip" v-show="formFocus.commun">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请正确填写主办单位通信地址，精确到门牌号
              </div>
            </div>
          </el-form-item>
          <el-form-item label="投资人信息：" prop="investor" :show-message="!formFocus.investor">
            <el-input v-model="ruleForm.investor" placeholder="请填写正确的投资人名称" @focus="formFocus.investor = true" @blur="formFocus.investor = false"></el-input>
            <div class="icp-tip" v-show="formFocus.investor">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请填写投资人信息！
              </div>
            </div>
          </el-form-item>
          <p class="info-write">负责人信息填写 &gt;&gt;</p>
          <el-form-item label="负责人姓名：" prop="boss_name">
            <el-input v-model="ruleForm.boss_name" placeholder="请填写负责人姓名" @focus="formFocus.boss_name = true" @blur="formFocus.boss_name = false"></el-input>
            <div class="icp-tip" v-show="formFocus.boss_name">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请填写负责人姓名
              </div>
            </div>
          </el-form-item>
          <el-form-item label="负责人证件类型：" prop="boss_certificate">
            <el-select v-model="ruleForm.boss_certificate" placeholder="--请选择--" @focus="formFocus.boss_certificate = true" @blur="formFocus.boss_certificate = false">
              <el-option
                v-for="item in ruleForm.zjlx"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div class="icp-tip" v-show="formFocus.boss_certificate">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请选择您负责人证件类型!
              </div>
            </div>
          </el-form-item>
          <el-form-item label="负责人证件号码：" prop="boss_number" :show-message="!formFocus.boss_number">
            <el-input v-model="ruleForm.boss_number" placeholder="请填写负责人证件号码" @focus="formFocus.boss_number = true" @blur="formFocus.boss_number = false"></el-input>
            <div class="icp-tip" v-show="formFocus.boss_number">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                填写的证件号码跟证件类型相对应！
              </div>
            </div>
          </el-form-item>
          <el-form-item label="负责人办公电话：" prop="tel">
            086-<el-input v-model="ruleForm.tel" style="width: 343px" placeholder="010-51661870" @focus="formFocus.tel = true" @blur="formFocus.tel = false"></el-input>
            <div class="icp-tip" v-show="formFocus.tel">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                格式：区号-号码，如：010-51661870
              </div>
            </div>
          </el-form-item>
          <el-form-item label="负责人手机号码：" prop="emetel" :show-message="!formFocus.emetel">
            <el-input v-model="ruleForm.emetel" @focus="formFocus.emetel = true" @blur="formFocus.emetel = false"></el-input>
            <div class="icp-tip" v-show="formFocus.emetel">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                需要接收管局下发的备案号与密码，请务必填写正确
              </div>
            </div>
          </el-form-item>
          <el-form-item label="负责人电子邮箱：" prop="test" :show-message="!formFocus.email">
            <el-input v-model="ruleForm.email" placeholder="请填写负责人电子邮箱" @focus="formFocus.email = true" @blur="formFocus.email = false"></el-input>
            <div class="icp-tip" v-show="formFocus.email">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请填写负责人电子邮箱
              </div>
            </div>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input type="textarea" v-model="ruleForm.remark" @focus="formFocus.remark = true" @blur="formFocus.remark = false"></el-input>
            <div class="icp-tip" v-show="formFocus.remark">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                如需其他帮助请留言，三丰云备案中心将竭诚为您服务~
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="z-display-inlineBlock z-lineHeight-20 ">
              <xbutton font="暂存草稿" type="orange" @XbuttonService="zancunForm('ruleForm')"/>
            </div>
            <div class="z-display-inlineBlock z-lineHeight-20 z-margin-left-50-precent">
              <xbutton font="下一步" type="orange" @XbuttonService="submitForm('ruleForm')"/>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import XfromInput from 'commons/XfromInput.vue'
  import XbeianCity from 'commons/XbeianCity.vue'
  import Xbutton from 'components/commons/Xbutton.vue'
  import beianService from 'business/beianService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data() {
      return {
        dialogLoading:false,
        sessionBeian:{},
        labelPosition: 'right',
        DISTRICTS:[],
        cityInfo: {
          province:'北京市',
          city:'市辖区',
          area:'东城区'
        },
        cityId:{
          provinceid: 0,
          cityid: 1,
          districtid: 1
        },
        ruleForm: {
          name:'',
          dwxz:[],
          zjlx:[],
          nature: '',
          certificate: '',
          number:'',
          address:'',
          commun:'',
          investor:'',
          boss_name:'',
          tel:'',
          emetel:'',
          email:'',
          remark:'',
          boss_certificate:'',
          boss_number:'',
          test:''
        },
        rules: {
          name: [
            { required: true, message: '请填写证件上的单位或机构名称！', trigger: 'blur' }
          ],
          nature: [
            { required: true, message: '', trigger: 'change' }
          ],
          certificate: [
            { required: true, message: '', trigger: 'change' }
          ],
          number: [
            { required: true, message: '请填写正确的证件号码！', trigger: 'blur' },
          ],
          address: [
            { required: true, message: '请与证件地址保持一致，4-250个字符', trigger: 'blur' },
          ],
          commun: [
            { required: true, message: '请正确填写主办单位通信地址，精确到门牌号', trigger: 'blur' },
          ],
          investor: [
            { required: true, message: '请填写投资人信息！', trigger: 'blur' },
          ],
          boss_certificate: [
            { required: true, message: '请选择您负责人证件类型!', trigger: 'change' }
          ],
          boss_number: [
            { required: true, message: '请填写正确的证件号码！', trigger: 'blur' }
          ],
          emetel: [
            { required: true, message: '请输入正确的负责人手机号码！', trigger: 'blur' },
          ],
          email: [
            { required: true, message: '邮箱格式不正确或长度超过45位', trigger: 'blur' },
          ],
        },
        formFocus: {
          name:false,
          nature: false,
          certificate: false,
          number:false,
          address:false,
          commun:false,
          investor:false,
          boss_name:false,
          boss_certificate:false,
          boss_number:false,
          tel:false,
          emetel:false,
          email:false,
          remark:false
        }
      };
    },
    props:{
      hide:Boolean
    },
    components: {
      XfromInput,
      Xbutton,
      XbeianCity,
      XdialogLoading
    },
    mounted() {
      this.sessionBeian = sessionStorage.getItem('beian') ? JSON.parse(sessionStorage.getItem('beian')) : {}
      if(this.sessionBeian.beian_path){
        this.beianInfo()
      }
    },
    computed: {
      boss_certificate() {
        return this.ruleForm.boss_certificate
      },
    },
    watch:{
      boss_certificate(newValue){
        if(newValue == 2){
          this.rules.boss_number.push({ validator: function (rule, value, callback) {
              let idCardRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
              if (!idCardRegex.test(value)) {
                callback(new Error('请输入有效的18位身份证号！'))
              } else {
                callback();
              }
            },trigger: 'blur'})
        }else{
          this.rules.boss_number.pop()
        }
      },
    },
    methods:{
      ...mapActions(['FIRSTBEIAN']),
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      zancunForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.zancun()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      async beianInfo() {
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST','cmd=get_dm')
        if(state.code === '000' ) {
          this.DISTRICTS = vueData.qy
          this.ruleForm.nature = [...vueData.dwxz.filter(item => item.id === this.sessionBeian.dwxz)][0].mc
          this.ruleForm.certificate = [...vueData.zjlx.filter(item => item.id === this.sessionBeian.zjlx)][0].mc
          this.ruleForm.number = this.sessionBeian.zjhm
          this.ruleForm.boss_certificate = '2'
          /*this.ruleForm.boss_number = this.sessionBeian.zjhm*/
          this.ruleForm.dwxz = vueData.dwxz.map((item, index) => {
            return {
              value: item.id,
              label: item.mc
            }
          })
          this.zjlxArr = vueData.zjlx.map((item, index) => {
            return {
              value: item.id,
              label: item.mc,
              dwflid: item.dwflid
            }
          })
          this.ruleForm.zjlx = [...this.zjlxArr.filter(item => item.dwflid == 5)]
          for(let i in this.DISTRICTS){
            if(this.DISTRICTS[i].id == this.sessionBeian.shengid){
              this.cityInfo.province = this.DISTRICTS[i].mc
              let province = this.DISTRICTS[i].shi
              for(let j in province){
                if(province[j].id == this.sessionBeian.shiid){
                  this.cityInfo.city = province[j].mc
                  let city = province[j].xian
                  for(let k in city){
                    if(city[k].id == this.sessionBeian.xianid){
                      this.cityInfo.area = city[k].mc
                    }
                  }
                }
              }
            }
          }
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async submit() {
        for(let i in this.DISTRICTS){
          if(this.DISTRICTS[i].mc == this.cityInfo.province){
            this.cityId.provinceid = Number(this.DISTRICTS[i].id)
            let province = this.DISTRICTS[i].shi
            for(let j in province){
              if(province[j].mc == this.cityInfo.city){
                this.cityId.cityid=Number(province[j].id)
                let city = province[j].xian
                for(let k in city){
                  if(city[k].mc == this.cityInfo.area){
                    this.cityId.districtid=Number(city[k].id)
                  }
                }
              }
            }
          }
        }
        let data = 'cmd=zhuti_edit'
                   +'&cmd_type=add'
                   +'&ba_path='+ this.sessionBeian.beian_path
                   +'&dwmc='+ this.ruleForm.name
                   + '&dwxz='+ this.sessionBeian.dwxz
                   + '&zjlx=' + this.sessionBeian.zjlx
                   + '&zjhm=' + this.ruleForm.number
                   + '&zjzs=' + this.ruleForm.address
                   + '&tzr=' + this.ruleForm.investor
                   + '&xxdz=' + this.ruleForm.commun
                   + '&shengid=' + this.cityId.provinceid
                   + '&shiid=' + this.cityId.cityid
                   + '&xianid=' + this.cityId.districtid
                   + '&fzr_xm=' + this.ruleForm.boss_name
                   + '&fzr_sjhm=' + this.ruleForm.emetel
                   + '&fzr_dhhm=' + this.ruleForm.tel
                   + '&fzr_zjlx=' + this.ruleForm.boss_certificate
                   + '&fzr_zjhm=' + this.ruleForm.boss_number
                   + '&fzr_dzyj=' + this.ruleForm.email
                   + '&bz=' + this.ruleForm.remark
        this.dialogLoading = true
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
            self.FIRSTBEIAN(JSON.stringify({
              taskid:vueData.taskid,
              ztxtid:vueData.ztxtid,
              beian_path:self.sessionBeian.beian_path
            }))
            self.$router.push('/beian9')
          }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      async zancun() {
        for(let i in this.DISTRICTS){
          if(this.DISTRICTS[i].mc == this.cityInfo.province){
            this.cityId.provinceid = Number(this.DISTRICTS[i].id)
            let province = this.DISTRICTS[i].shi
            for(let j in province){
              if(province[j].mc == this.cityInfo.city){
                this.cityId.cityid=Number(province[j].id)
                let city = province[j].xian
                for(let k in city){
                  if(city[k].mc == this.cityInfo.area){
                    this.cityId.districtid=Number(city[k].id)
                  }
                }
              }
            }
          }
        }
        let data = 'cmd=zhuti_edit'
                   +'&cmd_type=add'
                   +'&ba_path='+ this.sessionBeian.beian_path
                   +'&dwmc='+ this.ruleForm.name
                   + '&dwxz='+ this.sessionBeian.dwxz
                   + '&zjlx=' + this.sessionBeian.zjlx
                   + '&zjhm=' + this.ruleForm.number
                   + '&zjzs=' + this.ruleForm.address
                   + '&tzr=' + this.ruleForm.investor
                   + '&xxdz=' + this.ruleForm.commun
                   + '&shengid=' + this.cityId.provinceid
                   + '&shiid=' + this.cityId.cityid
                   + '&xianid=' + this.cityId.districtid
                   + '&fzr_xm=' + this.ruleForm.boss_name
                   + '&fzr_sjhm=' + this.ruleForm.emetel
                   + '&fzr_dhhm=' + this.ruleForm.tel
                   + '&fzr_zjlx=' + this.ruleForm.boss_certificate
                   + '&fzr_zjhm=' + this.ruleForm.boss_number
                   + '&fzr_dzyj=' + this.ruleForm.email
                   + '&bz=' + this.ruleForm.remark
        this.dialogLoading = true
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          this.$dialog({type:'success', info: vueData.msg, click () {}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .alert-warn {
    margin-bottom: 30px;
  }
  .beian-ruleForm .el-input,.el-select,.el-textarea {
    width: 374px;
  }
  .captcha .el-form-item__error {
    left: 380px;
  }
  .icp-msg {
    color: #4074e1;
    border: solid 1px #4074e1;
    background: #ecf1fc;
    border-radius: 3px;
    position: relative;
    margin-top: 10px;
    font-size: 12px;
    line-height: 18px;
    padding: 10px;
    width: 352px;
  }
  em{
    font-style: normal;
    font-weight: 500;
  }
  .icp-tip {
    position: absolute;
    left: 375px;
    top: 0;
    margin-left: 10px;
    width: 400px;
    line-height: 32px;
    font-size: 12px;
  }
  .icp-tip .icp-msg {
    margin: 0 0 0 30px;
    padding: 6px 10px;
    width: 300px;
  }
  .icp-tip span {
    padding-left: 26px;
  }
  .hoticon-left {
    position: absolute;
    top: 12px;
    left: -4px;
    background: url(../../assets/imgs/hoticon.png) no-repeat;
    background-position: 0 -5px;
    width: 4px;
    height: 6px;
  }
  .icon-i {
    color: #4074e1;
    padding-left: 5px;
  }
  .info-write {
    font-size: 20px;
    color: #333;
    line-height: 84px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/beian/beian6.vue